var initialState = {
    byId: []
};

export default (state = initialState, action) => {
    if (action.payload?.entities?.resource) {
        state = {
            ...state,
            byId: {
                ...state.byId,
                ...action.payload.entities.resource
            }
        }
    }
    switch (action.type) {
        default:
            return state;
    }
};